import { urls } from "../../../../utils/UrlConstant";
import { privateFetch } from "../../../../utils/PrivateFetch";
import { properties } from "../../../../utils/Properties_es";
import qs from "qs";
import { validateResponseError } from "../../../others/ValidateServices";
export const SVFindRequest = async (filter, page, allRecords) => {
  let responseData = {};
  const params = new URLSearchParams([
    ["filtro", filter && filter !== "" ? filter : ""],
    ["pagina", page],
    [
      "registroXPagina",
      allRecords ? 0 : process.env.REACT_APP_REGISTRATION_X_PAGE,
    ],
  ]);
  await privateFetch
    .get(urls.REQUEST_ROL_LIST, { params })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      validateResponseError(
        error,
        properties.com_feria_label_rol_find_error,
        false
      );
    });
  return responseData;
};

export const SVFindAuthoritiesByRol = async (rolId) => {
  let responseData = {};
  const params = new URLSearchParams([
    ["id", rolId],
  ]);
  await privateFetch
    .get(urls.REQUEST_ROL_AUTHORITIES_BY_ID, { params })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      validateResponseError(
        error,
        properties.com_feria_label_rol_authorities_error,
        false
      );
    });
  return responseData;
};

export const SVFindByIdRequest = async (id) => {
  let responseData = {};
  const params = new URLSearchParams([["id", id]]);

  await privateFetch
    .get(urls.REQUEST_ROL_ID, {
      params,
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      validateResponseError(
        error,
        properties.com_feria_label_rol_findid_error,
        false
      );
    });
  return responseData;
};

export const SVSaveRequest = async (data) => {
  let responseData = {};
  const requestBody = {
    Codigo: data.code,
    Descripcion: data.description,
    AplicaEncuesta: data.applySurvey ? true : false, 
  };
  await privateFetch
    .post(urls.REQUEST_ROL, qs.stringify(requestBody))
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      validateResponseError(
        error,
        properties.com_feria_label_rol_save_error,
        false
      );
    });
  return responseData;
};

export const SVUpdateRequest = async (id, data) => {
  let responseData = {};
  const requestBody = {
    Id: id,
    Codigo: data.code,
    Descripcion: data.description,
    AplicaEncuesta: data.applySurvey ? true : false, 
  };
  await privateFetch
    .put(urls.REQUEST_ROL, qs.stringify(requestBody))
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      validateResponseError(
        error,
        properties.com_feria_label_rol_update_error,
        false
      );
    });
  return responseData;
};

export const SVDeleteRequest = async (id) => {
  let responseData = {};
  const params = new URLSearchParams([["id", id]]);
  await privateFetch
    .delete(urls.REQUEST_ROL, {
      params,
    })
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      validateResponseError(
        error,
        properties.com_feria_label_rol_delete_error,
        false
      );
    });
  return responseData;
};
